import React from 'react';
import { makeKey } from '../hooks/useConvertForTranslationKey';
const AYMING_BLUE = '#00aeef';
const NestedTasksTable = _ref => {
  let {
    task,
    claimGroup,
    selectedIndex,
    markTaskComplete,
    t
  } = _ref;
  if (!task?.tasks?.length) {
    return /*#__PURE__*/React.createElement("p", {
      style: {
        color: '#6B7280',
        fontSize: '13px'
      }
    }, t('no_tasks') || 'No tasks for this section.');
  }
  return /*#__PURE__*/React.createElement("div", {
    style: {
      background: '#F9FAFB',
      borderRadius: '8px',
      padding: '1rem 1.25rem',
      border: '0.5px solid #E5E7EB'
    }
  }, /*#__PURE__*/React.createElement("p", {
    style: {
      fontSize: '11px',
      fontWeight: 500,
      color: AYMING_BLUE,
      marginBottom: '0.75rem',
      textTransform: 'uppercase',
      letterSpacing: '0.05em'
    }
  }, t(makeKey(task.category_title))), /*#__PURE__*/React.createElement("table", {
    style: {
      width: '100%',
      borderCollapse: 'collapse',
      fontSize: '16px'
    }
  }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", {
    style: {
      borderBottom: '1.5px solid #E5E7EB'
    }
  }, /*#__PURE__*/React.createElement("th", {
    style: {
      textAlign: 'left',
      padding: '12px 0',
      fontWeight: 500,
      color: '#111827'
    }
  }, t('task_name')), /*#__PURE__*/React.createElement("th", {
    style: {
      textAlign: 'center',
      padding: '12px 0',
      fontWeight: 500,
      color: '#111827',
      width: '160px'
    }
  }, t('status')), markTaskComplete && /*#__PURE__*/React.createElement("th", {
    style: {
      textAlign: 'right',
      padding: '12px 0',
      fontWeight: 500,
      color: '#111827',
      width: '160px'
    }
  }, t('actions')))), /*#__PURE__*/React.createElement("tbody", null, task.tasks.map((subTask, taskIndex) => /*#__PURE__*/React.createElement("tr", {
    key: taskIndex,
    style: {
      borderBottom: '1px solid #F3F4F6'
    }
  }, /*#__PURE__*/React.createElement("td", {
    style: {
      padding: '18px 0',
      color: '#374151'
    }
  }, t(makeKey(subTask.title))), /*#__PURE__*/React.createElement("td", {
    style: {
      padding: '18px 0',
      textAlign: 'center'
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      display: 'inline-flex',
      alignItems: 'center',
      gap: '8px',
      fontSize: '15px',
      fontWeight: 500,
      color: subTask.completed ? '#059669' : '#D97706'
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      width: '10px',
      height: '10px',
      borderRadius: '50%',
      background: subTask.completed ? '#10B981' : '#F59E0B',
      flexShrink: 0
    }
  }), subTask.completed ? t('validated') || 'Completed' : t('pending') || 'Pending')), markTaskComplete && /*#__PURE__*/React.createElement("td", {
    style: {
      padding: '18px 0',
      textAlign: 'right'
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "cursor-pointer",
    onClick: () => markTaskComplete(task, selectedIndex, taskIndex, claimGroup)
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      display: 'inline-flex',
      alignItems: 'center',
      gap: '6px',
      fontSize: '15px',
      fontWeight: 500,
      color: AYMING_BLUE,
      cursor: 'pointer'
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: "material-icons",
    style: {
      fontSize: '18px'
    }
  }, subTask.completed ? 'close' : 'done'), subTask.completed ? t('cancel_task') : t('validate_task')))))))));
};
export default NestedTasksTable;